// extracted by mini-css-extract-plugin
export default {"container":"App_container__9hY0o","arrow":"App_arrow__hUROo","titleFont":"App_titleFont__Ew6EN","dot":"App_dot__gvmTY"};